import api from 'infra/config/api';

export default function homeService() {
    return api
    .url('/home.php')
    .get()
    .json();
}